import Login from './login';
import Registration from './registration';
import RegistrationSuccess from './registration-success';
import ForgetPassword from './forgot-password';
import ForgotPasswordSuccess from './forgot-password-success';
import Privacy from './privacy';
import Terms from './terms';
import UpdateUser from './update-user';
import ChangePassword from './change-password';
import ResetPassword from './reset-password';
import Dashboard from './dashboard';
import Report from './report';
import SetSupplier from './set-supplier';
import Tender from './tender';
import CustomizeReports from './customize-reports';
import MyRequests from './my-requests';

export const commonRoutes = [
    Terms,
    ForgotPasswordSuccess,
    RegistrationSuccess,
    Privacy,
    SetSupplier
];

export const authRoutes = [
    Login,
    Registration,
    ForgetPassword,
    ResetPassword,
];

export const privateRoutes = [UpdateUser, ChangePassword, Dashboard, Report,Tender, CustomizeReports, MyRequests];
